/**
 *  Return default state for setup stored
 *
 * @returns { object} Default state object
 */
export function getDefaultState() {
  return {
    assignments: {},
    categoriesForAssignments: {},
    submissionsForAssignmentMap: {},

    assignmentsForSectionMap: {},

    gradeTypes: [],
    assignmentGradeTypeMap: {}
  };
}

const state = getDefaultState();

export default state;
